<template lang="html">
  <div id="presion" class="container-fluid">
    <div id="formulario-top">
      <div class="row">
        <div class="col-sm-2 col-sm-offset-3">
          <select-c name="estaciones" id="estaciones" :options="options" placeholder="ESTACIONES"></select-c>
        </div>
        <div class="col-sm-2">
          <select-c name="separacion" id="separacion" :options="options" placeholder="SEPARACIÓN" ></select-c>
        </div>
        <div id="" class="col-sm-2">
          <button class="btn btn-default waves-effect waves-light">
            Buscar
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-xs-12">
          <div class="panel-body">
            <table class="table">
              <thead>
                <tr class="text-center nombre-alarma">
                  <th style="width: 250px;">Fecha
                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                  </th>
                  <th>Lat</th>
                  <th>Lng</th>
                  <th>Km</th>
                  <th>Tramo</th>
                  <th>Tipo</th>
                  <th>Asignación</th>
                </tr>
              </thead>
              <tbody v-for="(row, key, index) in alarmType" :id="'alarm-' + key" :key="key">
               <tr class="text-center">
                  <th style="width: 250px;">2016-07-21
                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                  </th>
                  <th>132.5	</th>
                  <th>-5.2134	</th>
                  <th>1234</th>
                  <th>toluca-df</th>
                  <th>1</th>
                  <th></th>
                </tr>
              </tbody>
            </table>
          </div>
        <div class="col-md-6 col-xs-12" style="margin: 0; padding:0;">
          <google-maps cclass="col-md-6 col-xs-12" :mcStyle="mcStyle" mcClass="half" :wStyle="wStyle"></google-maps>
        </div>

      </div>
    </div>
    </div>
    <div id="graficas" class="row">
    <div class="col-md-3 col-xs-12 nomen">
        <h4>Nomenclatura</h4>
        <div class="col-md-3" style="text-align:right;">
            <hr style="background-color:red; height:3px; width:50px; margin-bottom:35px!important; margin-top:15px!important;">
            <hr style="background-color:#36A2EB; height:3px; width:50px; margin-bottom:35px!important; margin-top:15px!important;">
            <hr style="background-color:#FFCE56; height:3px; width:50px; margin-bottom:35px!important; margin-top:15px!important;">
        </div>
        <div class="col-md-9" style="text-align:left;">
        <p class="nomen-p">REP SALAMANCA</p>
        <p class="nomen-p">VS STA ELENA</p>
        <p class="nomen-p">VS STA MONICA</p>
        </div>

    </div>
        <div class="col-md-9 col-xs-12">
          <div class="panel-body" id="app">
            <line-chart
              id="line"
              :data="line"
              xkey="year"
              ykeys='[ "and", "ios", "win" ]'
              line-colors='[ "#FF0000", "#36A2EB", "#FFCE56" ]'
              grid="true"
              grid-text-weight="bold"
              resize="true">
            </line-chart>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import selectC from 'components/reusable/Select'
import { mapGetters } from 'vuex'
import Raphael from 'raphael/raphael'
global.Raphael = Raphael
import { LineChart } from 'vue-morris'
export default {
  data() {
    return {
    alarmType: '',
      options: {
        op1: {
          value: '2pm',
          name: '2:00 pm'
        },
        op2: {
          value: '2am',
          name: '2:00 am'
        },
        op3: {
          value: 'all',
          name: 'All'
        }
      },
      line: [
          { year: '2013', and:30, ios: 10, win:5 },
          { year: '2014', and:20, ios: 40, win:15 },
          { year: '2015', and:30, ios: 20, win:25 },
          { year: '2016', and:50, ios: 30, win:20 },
        ]
    }
  },
    computed: {
    ...mapGetters({
      type1: 'alarmType1',
    }),
  },
  components: {
    selectC,
    LineChart,
  },
   mounted() {
    this.alarmType = this.type1
    $('#map-div').css('z-index', '0')
    $('#example_id').ionRangeSlider({
      min: 0,
      max: 10000,
      from: 1000,
      to: 9000,
      type: 'double',
      prefix: 'KM ',
      grid: true,
      grid_num: 2
    })
  }
}
</script>

<style lang="scss" scoped>
@import '~varmix';
.container-fluid{
  margin: 0 ;
  padding: 0;
}
#presion {
  background-color: $bg;
  #formulario-top {
    height: 10vh;
    margin-top: 80px;
    border-bottom: 1px solid $inactive;
  }

  #graficas {
    height: 65vh;
  }

  .btn-default{
    margin-top: 0;
    background-color: $amarilloC;
    &:hover, &:active, &:focus{
      background-color: $amarilloO !important;
    }
  }
}
.nomen{
    height:100%;
    border-right:3px solid gray;
    text-align:center;
}



table,
.panel-body {
  overflow: scroll;
  height: 32vh;
  // width: 50vw;
  padding: 0px 0 0 0;
  border-bottom:1px solid #999;
  margin: 20px 0px;
  @include tablet{
    padding: 0;
  }
  .info {
    td {
      background-color: $bg;
    }
  }
  th {
    text-align: left;
    padding-left: 25px;
    @include cMax(415px) {
      font-size: 12px;
    }
  }
  td {
    text-align: left;
    padding-left: 25px;
    i {
      color: $inactive;
      cursor: pointer;
      &:hover {
        color: $amarilloC;
      }
    }
  }
  .nombre-alarma {
    background-color: $amarilloC;
    color: white;
  }
  .panel-body {
    padding: 0;
  }
  .panel-title {
    @include cMax(415px) {
      font-size: 12px;
    }
  }
}
</style>





// WEBPACK FOOTER //
// Volumetria.vue?ee1db7ba